import { GridContainer } from 'libs/ui';
import { Epm } from 'grids/epm/epm';

export const EpmWrapper = (props) => {  
  return (
    <GridContainer>
      <Epm {...props} />
    </GridContainer>
  );
};
